import React, {useContext, useState} from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faCaretDown,
  faList,
  faCaretUp,
} from "@fortawesome/free-solid-svg-icons";

import { useTranslation } from "react-i18next";
import RequestDataDeleteDialog from "./RequestDataDeleteDialog";
import InitContext from "../pages/InitContext";

const NavigationBarForTablet = ({ onResetApp }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const [showMenuButtonDropdown, setShowMenuButtonDropdown] = useState(false);
  const [showDiaryItems, setShowDiaryItems] = useState(false);
  const [showProfileItems, setShowProfileItems] = useState(false);
  const [showDrugInfoItems, setShowDrugInfoItems] = useState(false);

  const [showRequestDataDeleteDialog, setShowRequestDataDeleteDialog] =
    useState(false);

  const toggleMenuButtonDropdown = () => {
    setShowMenuButtonDropdown(!showMenuButtonDropdown);
  };

  const toggleDiaryItems = () => {
    setShowDiaryItems(!showDiaryItems);
  };

  const toggleProfileItems = () => {
    setShowProfileItems(!showProfileItems);
  };

  const toggleDrugInfoItems = () => {
    setShowDrugInfoItems(!showDrugInfoItems);
  };

  const handleShowDeleteDataRequestDialog = () => {
    setShowRequestDataDeleteDialog(true);
  };

  const handleCancelRequestDataDelete = () => {
    setShowRequestDataDeleteDialog(false);
  };

  const handleRequestDataDeleteSubmitted = () => {
    setShowRequestDataDeleteDialog(false);
    onResetApp();
  };

  return (
    <div className="w3-dropdown-click w3-theme-l3">
      <button
        onClick={toggleMenuButtonDropdown}
        className="w3-btn w3-theme-l3 w3-hover-light-blue w3-left-align"
      >
        <FontAwesomeIcon icon={faList} />{" "}
        <FontAwesomeIcon icon={showMenuButtonDropdown ? faCaretDown : faCaretUp} />
      </button>
      <div
        className={`w3-dropdown-content w3-theme-l3 w3-bar-block menu-button-dropdown w3-border${
          showMenuButtonDropdown ? " w3-show" : ""
        }`}
      >
        <NavLink
          to={`/drugsTab/`}
          className={({ isActive }) =>
            isActive
              ? "w3-bar-item w3-hover-light-blue w3-theme-d3"
              : "w3-bar-item w3-hover-light-blue"
          }
        >
          <label>{t("medication_plan")}</label>
        </NavLink>
        <button
          className={`w3-btn w3-theme-l3 w3-hover-light-blue w3-block w3-left-align`}
          onClick={toggleDiaryItems}
        >
          <label>{t("diary")}</label>{" "}
          <FontAwesomeIcon icon={showDiaryItems ? faCaretUp : faCaretDown} />
        </button>
        <div
          className={`w3-bar-block w3-theme-l2 w3-card-2 w3-border menu-button-sub-menu${
            showDiaryItems ? " w3-show" : " w3-hide"
          }`}
        >
          <NavLink
            to={`/symptoms/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 sub-item"
                : "w3-bar-item w3-hover-light-blue sub-item"
            }
          >
            <label>{t("symptoms")}</label>
          </NavLink>
          <NavLink
            to={`/labValues/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 sub-item"
                : "w3-bar-item w3-hover-light-blue sub-item"
            }
          >
            <label>{t("lab_values")}</label>
          </NavLink>
          <NavLink
            to={`/measurements/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 sub-item"
                : "w3-bar-item w3-hover-light-blue sub-item"
            }
          >
            <label>{t("measurements")}</label>
          </NavLink>
        </div>
        <button
          className={`w3-btn w3-theme-l3 w3-hover-light-blue w3-block w3-left-align`}
          onClick={toggleDrugInfoItems}
        >
          <label>{t("medication_information")}</label>{" "}
          <FontAwesomeIcon icon={showDrugInfoItems ? faCaretUp : faCaretDown} />
        </button>
        <div
          className={`w3-bar-block w3-theme-l2 w3-card-2 w3-border menu-button-sub-menu${
            showDrugInfoItems ? " w3-show" : " w3-hide"
          }`}
        >
          <NavLink
            to={`/pdir/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3"
                : "w3-bar-item w3-hover-light-blue"
            }
          >
            <label>{t("medication_recommender")}</label>
          </NavLink>
          {context?.patient?.study_id?.toLowerCase() === "demo-hospital" && (
              <NavLink
                  to={`/pharmaOracle/`}
                  className={({ isActive }) =>
                      isActive
                          ? "w3-bar-item w3-hover-light-blue w3-theme-d3"
                          : "w3-bar-item w3-hover-light-blue"
                  }
              >
                <label>{t("pharma_oracle")}</label>
              </NavLink>
          )}
        </div>
        <button
          className={`w3-btn w3-theme-l3 w3-hover-light-blue w3-block w3-left-align`}
          onClick={toggleProfileItems}
        >
          <label>{t("profile")}</label>{" "}
          <FontAwesomeIcon icon={showProfileItems ? faCaretUp : faCaretDown} />
        </button>
        <div
          className={`w3-bar-block w3-theme-l2 w3-card-2 w3-border menu-button-sub-menu${
            showProfileItems ? " w3-show" : " w3-hide"
          }`}
        >
          {
            <NavLink
              to={`/patient/`}
              className={({ isActive }) =>
                isActive
                  ? "w3-bar-item w3-hover-light-blue w3-theme-d3 sub-item"
                  : "w3-bar-item w3-hover-light-blue sub-item"
              }
            >
              <label>{t("health")}</label>
            </NavLink>
          }
          <NavLink
            to={`/pgx/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 sub-item"
                : "w3-bar-item w3-hover-light-blue sub-item"
            }
          >
            <label>{t("pgx")}</label>
          </NavLink>
          <button
            className="w3-bar-item w3-hover-light-blue w3-theme-l2 sub-item"
            onClick={handleShowDeleteDataRequestDialog}
          >
            <label>{t("request_delete_my_data")}</label>
          </button>
        </div>
      </div>
      {showRequestDataDeleteDialog && (
        <RequestDataDeleteDialog
          showDialog={showRequestDataDeleteDialog}
          onConfirmRequestDataDelete={handleRequestDataDeleteSubmitted}
          onCancelRequestDataDelete={handleCancelRequestDataDelete}
        />
      )}
    </div>
  );
};

export default NavigationBarForTablet;
